<template>
  <v-container>
    <v-layout column>
      <h1 class="dpr-heading"><a :href='url'>{{park}}</a><span v-if="field"> • {{field}}</span></h1>
      <DetailFilters @change="search" ref="filters"/>
      <v-progress-linear indeterminate :active="loading" class="my-0"/>
      <v-tabs aria-label="Reservation display format">
        <v-tab key="calendar">Calendar</v-tab>
        <v-tab-item key="calendar"><CalendarResults :results="results"/></v-tab-item>
        <v-tab key="table">Table</v-tab>
        <v-tab-item key="table"><TableResults :results="results"/></v-tab-item>
      </v-tabs>
      <DetailButtons @change="search" :results="results"/>
      <br/>
      <LastUpdatedTimestamp/>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import client from '@/client'
  import CalendarResults from '@/components/CalendarResults'
  import DetailButtons from '@/components/DetailButtons'
  import DetailFilters from '@/components/DetailFilters'
  import LastUpdatedTimestamp from '@/components/LastUpdatedTimestamp'
  import TableResults from '@/components/TableResults'

  export default {
    data: () => ({
      loading: false,
      results: {cal: {}, list: []},
      park: '...',
      field: null,
      url: '#'
    }),
    components: {
      CalendarResults,
      DetailButtons,
      DetailFilters,
      LastUpdatedTimestamp,
      TableResults
    },
    mounted() {
      this.readRoute(this.$route)
    },
    watch: {
      $route (to) {
        this.readRoute(to)
      }
    },
    methods: {
      readRoute (to) {
        this.commit('parkCode', to.params.parkCode)
        if(to.params.fieldCode) {
          this.commit('fieldCode', to.params.fieldCode)
          this.commit('view', 'field')
        } else {
          this.commit('fieldCode', null)
          this.commit('view', 'park')
        }

        if(to.query){
          [
            ['purpose', null],
            ['reservee', null],
            ['month', moment().format('M')],
            ['year', moment().format('YYYY')]
          ].forEach(([filter, fallback]) => {
            const value = to.query[filter]
            this.commit(filter, value ? value : fallback)
          })
        }

        this.$nextTick(function() {
          this.setHeading()
          this.search()
          this.$refs.filters.init()
        })
      },
      setHeading () {
        const details = this.$store.state.details

        client.getParkFromCode(details.parkCode, details.view=='park' ? null : details.fieldCode)
          .then(park => {
            if(!park){
              // redirect to 404
            } else if(details.view=='field') {
              document.title = `${park.locationName} • ${park.facilityName}`
              this.park = park.locationName
              this.field = park.facilityName
              this.url = park.parkUrlText
            } else {
              document.title = park.locationName
              this.park = park.locationName
              this.url = park.parkUrlText
            }
          })
      },
      search () {
        this.loading = true
        client.getReservations(Object.assign(
          {parkCode: this.parkCode, fieldCode: this.fieldCode},
          this.$store.state.details
        ))
          .then(results => {
            this.results = results
          })
          .finally(() => {
            this.loading = false
          })
      },
      commit (filter, value) { this.$store.commit('setDetails', {filter, value}) }
    }
  }
</script>